<app-side-nav [notifications$]="notifications$">
  <router-outlet></router-outlet>
</app-side-nav>
